import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-white border shadow border-gray-400" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row justify-between bg-white px-4 py-6"
}
const _hoisted_3 = { class: "text-gray-900 text-base font-semibold" }

import { computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { IOption, ManagementDestinationOption, ManagementStepField } from '@/lib';
import {
  Diagnosis,
  ManagementPlanDestination,
  ManagementPlanDiagnosesGroupModel,
  ManagementPlanStep,
  ManagementPlanStepParam,
  ManagementPlanTimeframe
} from '@/models';
import { Condition } from '@/lib/components/Diagnosis';
import ManagementPlanStepAdder from './ManagementPlanStepAdder.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ManagementPlanDiagnosesGroup',
  props: {
  actionId: {
    type: String,
    default: ''
  },
  value: {
    type: Object as PropType<ManagementPlanDiagnosesGroupModel> as PropType<Array<ManagementPlanDestination>>,
    default: () => ({
      diagnoses: [],
      steps: [],
      destinations: []
    })
  },
  destinations: {
    type: Array,
    default: () => []
  },
  timeframes: {
    type: Array as PropType<Array<ManagementPlanTimeframe>>,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  }
},
  emits: ["edit", "delete", "addStep", "deleteStep", "updateStep"],
  setup(__props) {

const props = __props;

const { t } = useI18n();



const defaultField = computed(() => [
  {
    placeholder: t('custom.uhb.management.destination') as string,
    type: 'select',
    value: ''
  },
  {
    placeholder: t('custom.uhb.management.timeframe') as string,
    type: 'select',
    value: ''
  },
  {
    placeholder: t('custom.uhb.management.enter-notes') as string,
    type: 'text',
    value: ''
  }
]);
const diagnoses = computed<Array<Diagnosis>>(() => props.value.diagnoses);
const steps = computed<Array<ManagementPlanStep>>(() => props.value.steps);
const timeframeOptions = computed<Array<IOption>>(() => props.timeframes.map((timeframe) => ({
  label: timeframe.name,
  value: timeframe.id
})));
const destinationOptions = computed<Array<ManagementDestinationOption>>(() => props.destinations.map((destination) => ({
  label: destination.name,
  value: destination.id,
  require_timeframe: destination.require_timeframe
})));
const stepsValue = computed<Array<Array<ManagementStepField>>>(() => {
  if (steps.value.length > 0) {
    return steps.value.reduce((acc, val) => {
      acc.push([
        {
          step_id: val.id,
          placeholder: t('custom.uhb.management.destination') as string,
          type: 'select',
          value: val.destination.id
        },
        {
          step_id: val.id,
          placeholder: t('custom.uhb.management.timeframe') as string,
          type: 'select',
          value: val.timeframe.id
        },
        {
          step_id: val.id,
          placeholder: t('custom.uhb.management.enter-notes') as string,
          type: 'text',
          value: val.notes
        }
      ]);
      return acc;
    }, [] as Array<Array<ManagementStepField>>);
  }
  return [defaultField.value];
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(diagnoses), (diagnosis, diagnosisIndex) => {
      return (_openBlock(), _createBlock(_unref(Condition), {
        key: diagnosisIndex,
        class: _normalizeClass({ 'border-t': diagnosisIndex }),
        condition: diagnosis.condition ? diagnosis.condition.name : '',
        stage: diagnosis.stage ? diagnosis.stage.name : '',
        location: diagnosis.anatomy ? diagnosis.anatomy.name : '',
        status: diagnosis.status,
        presence: diagnosis.is_present,
        differential: diagnosis.is_differential,
        "show-actions": false
      }, null, 8, ["class", "condition", "stage", "location", "status", "presence", "differential"]))
    }), 128)),
    (!_unref(diagnoses).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('custom.uhb.diagnosis.unable')), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(ManagementPlanStepAdder, {
      class: "p-6 border-t rounded-b-lg bg-gray-100",
      value: _unref(stepsValue),
      fields: _unref(defaultField),
      loading: __props.loading,
      destinations: _unref(destinationOptions),
      timeframes: _unref(timeframeOptions),
      onAddStep: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('addStep', { ...$event, action_id: __props.actionId }))),
      onDeleteStep: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('deleteStep', { ...$event, action_id: __props.actionId }))),
      onUpdateStep: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('updateStep', { ...$event, action_id: __props.actionId })))
    }, null, 8, ["value", "fields", "loading", "destinations", "timeframes"])
  ]))
}
}

})